import cx from 'classnames';

import { Breadcrumb, BreadcrumbProps } from '../../../domains/Layout/Breadcrumb/Breadcrumb';
import { DestinationDestinationArticle } from '../../../domains/TravelGuide/Article/DestinationDestinationArticle';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { PickDomain } from '../../../shared/utilities/types/PickDomain';

import style from './Header.module.css';
import { TitleAndDescription } from './TitleAndDescription';

type HeaderProps = {
    destination: PickDomain<
        Destination,
        'id' | 'slug' | 'name' | 'preposition' | 'isAvailableForQuoteRequest'
    >;
    breadcrumbItems: BreadcrumbProps['items'];
    destinationArticle: PickDomain<DestinationDestinationArticle, 'contentStart'> | null;
};

export const Header = ({ destination, breadcrumbItems, destinationArticle }: HeaderProps) => {
    return (
        <div className={cx('mb-40', style.header)}>
            <div className="main-container mb-24">
                <Breadcrumb items={breadcrumbItems} reversed />
            </div>
            <TitleAndDescription
                destination={destination}
                destinationArticle={destinationArticle}
            />
        </div>
    );
};
